import React from 'react';
import Button from '@atlaskit/button';
import { Text } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import {
	useAnalyticsEvents,
	fireUIAnalytics,
	ContextualAnalyticsData,
	MountEvent,
	BANNER,
	fireScreenAnalyticsDeferred,
} from '@atlassian/jira-product-analytics-bridge';
import { useRequestTypeFieldsLayoutPreference } from '../../../controllers/request-type-fields-layout-user-preference/index.tsx';
import messages from './messages.tsx';

const learnMoreLink =
	'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';

export const JsmRequestTypeFieldsChangeboarding = () => {
	const [{ data: isRequestTypeFieldsLayoutEnabled }] = useRequestTypeFieldsLayoutPreference();
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClickLearnMoreLink = () =>
		fireUIAnalytics(
			createAnalyticsEvent({}),
			'jsmRequestTypeFieldsChangeboardingLearnMoreLink clicked',
		);

	return (
		<ContextualAnalyticsData sourceType={BANNER} sourceName="jsmRequestTypeFieldsChangeboarding">
			<MountEvent onMount={fireScreenAnalyticsDeferred} />
			<SectionMessage
				appearance="discovery"
				actions={
					<Button
						appearance="link"
						spacing="none"
						onClick={onClickLearnMoreLink}
						onAuxClick={onClickLearnMoreLink}
						href={learnMoreLink}
						target="_blank"
					>
						{!isRequestTypeFieldsLayoutEnabled
							? formatMessage(
									expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
										? messages.sectionMessageLearnMoreWhenToggleOffIssueTermRefresh
										: messages.sectionMessageLearnMoreWhenToggleOff,
								)
							: formatMessage(messages.sectionMessageLearnMore)}
					</Button>
				}
			>
				<Text as="p">
					{!isRequestTypeFieldsLayoutEnabled
						? formatMessage(
								expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
									? messages.sectionMessageBodyWhenToggleOffIssueTermRefresh
									: messages.sectionMessageBodyWhenToggleOff,
								{
									bold: (message: string) => <b>{message}</b>,
								},
							)
						: formatMessage(
								expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
									? messages.sectionMessageBodyIssueTermRefresh
									: messages.sectionMessageBody,
							)}
				</Text>
			</SectionMessage>
		</ContextualAnalyticsData>
	);
};
